'use strict';

module.exports = {
  kmeans: 'kmeans',
  upload: 'upload',
  feed: 'feed',
  kmeansEdited: 'kmeans-edited',
  uploadEdited: 'upload-edited',
  defaultScheme: 'default',
  defaultEdited: 'default-edited',
  regional: 'regional',
  regionalEdited: 'regional-edited',
  simpleSwaps: 'simpleSwaps',
};
